module.exports = __webpack_public_path__ + "img/336.05a89e3b.png";